/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Billing_Amount_Excl_VatInputs */



/**
* | output |
* | --- |
* | "{amount} excl. VAT" |
*
* @param {Billing_Amount_Excl_VatInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const billing_amount_excl_vat = /** @type {((inputs: Billing_Amount_Excl_VatInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Amount_Excl_VatInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.amount} zzgl. MwSt.`)
	return /** @type {LocalizedString} */ (`${i?.amount} excl. VAT`)
});